import axios from "axios";

export const getSubjectInfoBySolutionId = async (solutionID) => {
    const data = await axios.get(`/api/solution/subject/${solutionID}`);
    return data.data;
};

export const getSubjectInfoByParentSubjectId = async (subjectID) => {
    const data = await axios.get(`/api/solution/subject/child/${subjectID}`);
    return data.data;
};

export const getContentInfoBySubjectId = async (subjectID) => {
    const data = await axios.get(`/api/solution/content/${subjectID}`);
    return data.data;
};

export const addSubject = async (solutionID, subject) => {
    await axios
        .post(`/api/solution/subject/${solutionID}?subject=${subject}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const addChlidSubject = async (subjectID, subject) => {
    await axios
        .post(`/api/solution/subject/child/${subjectID}?subject=${subject}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const deleteSubject = async (subjectID) => {
    let data = await axios
        .delete(`/api/solution/subject/${subjectID}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 500) {
                alert("해당 요소에 컨텐츠가 존재하여 삭제가 불가능합니다.");
            } else if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
    return data;
};

export const editSubject = async (subjectID, subject) => {
    await axios
        .put(`/api/solution/subject/${subjectID}?subject=${subject}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const editContentText = async (contentID, text) => {
    await axios
        .put(`/api/solution/content/${contentID}/text?text=${text}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const editContentImage = async (contentID, file) => {
    var fileData = new FormData();
    file && fileData.append("file", file);
    await axios
        .put(`/api/solution/content/${contentID}/file`, fileData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const addContentText = async (subjectID, text) => {
    await axios
        .post(`/api/solution/content/${subjectID}/text?text=${text}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const addContentImage = async (subjectID, file) => {
    var fileData = new FormData();
    fileData.append("file", file);

    const data = await axios
        .post(`/api/solution/content/${subjectID}/file`, fileData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const deleteContent = async (contentID) => {
    await axios
        .delete(`/api/solution/content/${contentID}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const modifyMoreInfoFlag = async (subjectID) => {
    await axios
        .put(`/api/solution/subject_more_info_flag/${subjectID}`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
}
